<template>
  <div id="departments">
    <el-card style="position: relative; padding-bottom: 20px">
      <div style="font-size: 16px">
        <!-- <b>{{ $t("message.title.workflow") }}: </b> -->
        <b>{{this.subClassName}}</b>
      </div>
    </el-card>
    <div class="content" style="background: #fff; padding-top: 30px">
      <el-button
        class="btn btn1"
        icon="el-icon-circle-plus-outline"
        @click="addNewStatus"
        >{{ $t("message.button.add") }}
    </el-button>
    <el-button
        class="btn btn3"
        icon="el-icon-sort"
        @click="sortTablePage"
        >{{ $t("message.button.order") }}
    </el-button>
    <el-button
        class="btn btn4"
        icon="el-icon-back"
        @click="gotoPPMWorkflowList"
        >{{ $t("message.button.return") }}
    </el-button>

    <div style="padding: 30px 0px 20px 20px;">
        <vxe-grid ref="xGrid" v-bind="gridOptions" @cell-dblclick="editStatus">

        <template v-slot:operate="{ row }">
            <vxe-button
            icon="el-icon-delete"
            :title="$t('message.button.delete')"
            circle
            @click="removeRowEvent(row)"
            >
            </vxe-button>
        </template>
        </vxe-grid>
    </div>
    <el-dialog :visible.sync="workflowStatusShow" @closed="statusEditClose">
      <div style="height: 40px">
            
            <el-button
              v-if="addBtn_Show"
              type="success"
              size="mini"
              style="float: right; margin-right: 10px; margin-top: 10px"
              @click="saveAddNewStatus('ruleForm')"
            >
              {{ $t("message.button.add") }}
            </el-button>
            <el-button
              v-else
              type="success"
              size="mini"
              style="float: right; margin-right: 10px; margin-top: 10px"
              @click="submitPageForm('ruleForm')"
            >
              {{ $t("message.button.save") }}
            </el-button>

          </div>
          <el-form
            ref="ruleForm"
            style="margin-top: 20px"
            label-width="150px"
            size="small"
          >
            <el-form-item :label="$t('message.table.name')" prop="name">
              <el-input
                v-model="wfData_edit.name"
                :style="input_width"

              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.table.type')">
              <el-select
                v-model="wfData_edit.statusType"
                :placeholder="$t('message.placeholder.select')"
                :style="input_width"
                :disabled="!addBtn_Show"
                @change="statusTypeChange"
              >
                <el-option
                  :label="$t('message.ppmWorkflowType.Pending')"
                  :value="1"
                >
                </el-option>
                <el-option
                  :label="$t('message.ppmWorkflowType.Progress')"
                  :value="2"
                ></el-option>
                <el-option
                  :label="$t('message.ppmWorkflowType.Complete')"
                  :value="3"
                ></el-option>
                <el-option
                  :label="$t('message.ppmWorkflowType.Reject')"
                  :value="4"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('message.table.isVerify')" v-if="isVerifyBtn_Show">
              <el-select
                v-model="wfData_edit.isVerify"
                :placeholder="$t('message.placeholder.select')"
                :style="input_width"
              >
                <el-option
                  :label="$t('message.table.no')"
                  :value="0"
                >
                </el-option>
                <el-option
                  :label="$t('message.table.yes')"
                  :value="1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
    </el-dialog>  

    <el-dialog :title="$t('message.table.listOrder')" :visible.sync="dialogSortTable">
        <div class="sortLists">
          <div
            class="sortList"
            style="border: none; color: #606266; font-weight: bold; background: #ebebeb"
          >
            <span style="margin-left: 40px; display: inline-block; width: 40%">{{
              $t("message.table.name")
            }}</span>
            <span style="display: inline-block; width: 30%">{{
              $t("message.table.type")
            }}</span>
            <span style="float: right; margin-right: 40px">{{
              $t("message.table.order")
            }}</span>
          </div>
        </div>
        <div class="sortLists" ref="example">
          <div class="sortList" v-for="(item, index) in sort_table_val" :key="index">
            <span style="margin-left: 40px; display: inline-block; width: 40%">{{
              item.name
            }}</span>
            <span style="display: inline-block; width: 30%">{{ item.statusType }}</span>
            <span style="float: right; margin-right: 40px">{{ item.statusOrder }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateSortClose">{{
            $t("message.button.cancel")
          }}</el-button>
          <el-button type="primary" @click="updateSort">{{
            $t("message.button.affirm")
          }}</el-button>
        </span>
      </el-dialog>
    </div>

  </div>

</template>

<style scoped>
.sortLists {
  width: 100%;
  border-top: 1px solid #ebebeb;
  border-right: 1px solid #ebebeb;
  border-left: 1px solid #ebebeb;
}

.sortList {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #ebebeb;
  line-height: 40px;
}
</style>

<script>
  import axios from "axios";
  import Sortable from "sortablejs";
  export default {
    name: 'PpmWorkflowInfo',
    data() {
      return {

        subClassName:'', //显示在第一行，表明是哪个subClass
        type_name_arr: [],//用来将后端传来的类型id，解析程类型名称

        sort_table_val: [],//用来存放所有项目状态的列表
        sort_table_val_old: [],//用来排序取消用

        dialogSortTable: false,//显示排序窗口
        isVerifyBtn_Show:true,

        wfData_edit: {//添加状态和编辑状态时使用
          id:"",
          name:"",
          statusType:"",
          isVerify:"",
        },
        addBtn_Show: false,//是否显示添加按钮
        workflowStatusShow: false,//是否显示添加编辑状态的窗口

        gridOptions: {
            keepSource: true,
            resizable: true,
            border: true,
            stripe: true,
            highlightHoverRow: true,
            highlightCurrentRow: true,
            showHeaderOverflow: true,
            showOverflow: true,
            rowId: "id",
            height: "530",
            size: "small",
            classId: [],
            columns: [
            {
                width: "35%",
                field: "name",
                title: this.$t("message.table.name"),
                editRender: {
                name: "$input",
                props: {
                    placeholder: this.$t("message.palceholder.input"),
                },
                },
            },
            {
                field: "statusType",
                title: this.$t("message.table.type"),
                editRender: {
                name: "$select",
                options: [
                    {
                    label: this.$t("message.ppmWorkflowType.Pending"),
                    value: 1,
                    },
                    {
                    label: this.$t("message.ppmWorkflowType.Progress"),
                    value: 2,
                    },
                    {
                    label: this.$t("message.ppmWorkflowType.Complete"),
                    value: 3,
                    },
                    {
                    label: this.$t("message.ppmWorkflowType.Reject"),
                    value: 4,
                    }
                ],
                },
            },
            {
                field: "isVerify",
                title: this.$t("message.table.isVerify"),
                editRender: {
                name: "$select",
                options: [
                    {
                    label: this.$t("message.table.no"),
                    value: 0,
                    },
                    {
                    label: this.$t("message.table.yes"),
                    value: 1,
                    },
                ],
                },
            },
            {
                title: this.$t("message.table.actions"),
                width: "15%",
                slots: {
                default: "operate",
                },
            },
            ],
            data: [],
            
            sortConfig: {
            trigger: "cell",
            },
        },
      }
    },
    mounted() {},
    methods: {
        statusTypeChange(val){
          if(val == 1 || val == 4){
            this.isVerifyBtn_Show = false;
          } else {
            this.isVerifyBtn_Show = true;
          };
        },
        gotoPPMWorkflowList(){//返回显示所有项目状态窗口
          // console.log("gotoPPMWorkflowList");
          this.$router.push("/ppmWorkflows");
        },
        srotTable() {
          var vm = this;
          var el = this.$refs["example"];
          console.log(el);
          //设置配置
          var ops = {
            animation: 150,
            ghostClass: "blue-background-class",
            // },
            onEnd: function (evt) {
              //拖拽结束发生该事件
              vm.sort_table_val.splice(
                evt.newIndex,
                0,
                vm.sort_table_val.splice(evt.oldIndex, 1)[0]
              );
              var newArray = vm.sort_table_val.slice(0);
              vm.sort_table_val = [];
              vm.$nextTick(function () {
                vm.sort_table_val = newArray;
              });
            },
          };
          //初始化
          var sortable = Sortable.create(el, ops);
        },
        //保存排序结果
        updateSort() {
          console.log(this.sort_table_val);
          var vm = this;
          var data = {
            statusList: [],
          };
          for (var i = 0; i < this.sort_table_val.length; i++) {
            var obj = {};
            obj.id = this.sort_table_val[i].id;
            var name = this.sort_table_val[i].statusType;
            obj.statusType = this.type_name_arr.indexOf(name)+1;
            console.log(name);
            console.log(obj.statusType);
            data.statusList.push(obj);
          }
          axios
            .post("/ppm/projectStatus/sortProjectStatus", data)
            .then(function (res) {
              if (res.data.code == 200) {
                console.log(res);
                vm.$message({
                  type: "success",
                  message: res.data.message,
                });
                vm.dialogSortTable = false;
                vm.loadStatus();
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        },
        //关闭排序窗口
        updateSortClose() {
          this.dialogSortTable = false;
          this.sort_table_val = this.deepClone(this.sort_table_val_old);
          var vm = this;
          var el = this.$refs["example"];
          var sortTable = Sortable.create(el);
          sortTable.destroy(); //销毁排序
        },

        //删除状态
        removeRowEvent(row) {
    
            this.$confirm(
              this.$t("message.confirm.deleteList"),
              this.$t("message.tips.tip"),
              {
                confirmButtonText: this.$t("message.button.affirm"),
                cancelButtonText: this.$t("message.button.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                axios
                  .get("/ppm/projectStatus/deleteProjectStatus?id=" + row.id)
                  .then((res) => {
                    if (res.data.code == 200) {
                      //console.log(res);
                      this.$message({
                        type: "success",
                        message: res.data.message,
                      });
                      this.loadStatus();
                    }
                  })
                  .catch();
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: this.$t("message.tips.deleteCancel"),
                });
              });
          // }
        },
        //双击状态，用来打开编辑状态窗口
        editStatus(rowInfo){
          let row = rowInfo.row;
          console.log(row);
          this.wfData_edit.name = row.name;
          this.wfData_edit.statusType = row.statusType;
          this.wfData_edit.isVerify = row.isVerify;
          this.wfData_edit.id = row.id;
          this.workflowStatusShow = true;

          if(row.statusType == 1 || row.statusType == 4){
            this.isVerifyBtn_Show = false;
          } else {
            this.isVerifyBtn_Show = true;
          };
        },
        //保存编辑状态
        submitPageForm(formName) {

          this.wfData_edit.name = this.wfData_edit.name.trim();
          if (!this.wfData_edit.name ||this.wfData_edit.name.match(/^[ ]*$/)) {
            this.$message.error(this.$t('message.error.name'))
            return false
          }

          var obj = this.deepCopy(this.wfData_edit);
          console.log(this.wfData_edit);
          console.log(obj);
          obj = Object.assign({ subclassId: this.$store.state.listId }, obj);
          console.log(obj);
          axios
            .post("/ppm/projectStatus/updateProjectStatus", obj)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.workflowStatusShow = false;
                this.loadStatus();
              }
            })
            .catch();

        },
        //添加新的状态
        saveAddNewStatus(formName) {
          console.log("saveAdd");
          this.wfData_edit.name = this.wfData_edit.name.trim();
          if (!this.wfData_edit.name ||this.wfData_edit.name.match(/^[ ]*$/)) {
            this.$message.error(this.$t('message.error.name'))
            return false
          }
          // this.wfData_edit.statusType = this.wfData_edit.statusType.trim();
          if (this.wfData_edit.statusType === "") {
            this.$message.error(this.$t('message.error.type'))
            return false
          }
          var obj = this.deepCopy(this.wfData_edit);
          console.log(this.wfData_edit);
          console.log(obj);
          obj = Object.assign({ subclassId: this.$store.state.listId }, obj);
          console.log(obj);
          axios
            .post("/ppm/projectStatus/saveProjectStatus", obj)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.workflowStatusShow = false;
                this.loadStatus();
              }
            })
            .catch();
        },

        //关闭添加编辑状态窗口
        statusEditClose() {
          this.wfData_edit = {
            id:"",
            name:"",
            statusType:"",
            isVerify:"",
          };
          this.addBtn_Show = false;
        },
        //加载所有项目状态
        loadStatus() {
            this.input_width = this.Global.input_width;
            axios
                .get("/ppm/projectStatus/getStatusBySubclassId?subclassId=" + this.$store.state.listId)
                .then((res) => {
                    console.log(res);
                    const resData = res.data.object.projectStatusList;
                    console.log(resData);
                    this.gridOptions.data = res.data.object.projectStatusList;

                    this.sort_table_val = this.deepClone(res.data.object.projectStatusList);

                    for (var i = 0; i < this.sort_table_val.length; i++) {
                      this.sort_table_val[i].statusType = this.type_name_arr[
                        this.sort_table_val[i].statusType-1
                      ];
                    };

                    this.sort_table_val_old = this.deepClone(this.sort_table_val);
                })
                .catch((error) => {
                //console.log(error);
                });
        },

        addNewStatus() {
          this.workflowStatusShow = true;
          this.addBtn_Show = true;
        },   
        sortTablePage() {
          var vm = this;
          this.sort_table_val = this.deepClone(this.sort_table_val_old);//fix 524 
          this.dialogSortTable = true;
          this.$nextTick(() => {
              vm.srotTable();
          });
        },
    },

    created() {
        this.loadStatus();
        this.subClassName = this.$store.state.listName;
        this.type_name_arr = [
          this.$t("message.ppmWorkflowType.Pending"),
          this.$t("message.ppmWorkflowType.Progress"),
          this.$t("message.ppmWorkflowType.Complete"),
          this.$t("message.ppmWorkflowType.Reject"),
          this.$t("message.ppmWorkflowType.Cancel"),
          this.$t("message.ppmWorkflowType.Hold"),
        ];//用来将后端传来的类型id，解析程类型名称

    },

    mounted(){
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      }

    }
  };
</script>